import React from "react"
import { Tag, Flex, Typography } from "antd"
import { DeleteOutlined, CheckOutlined } from "@ant-design/icons"
import Separator from "ui/Separator"
import IconWithBg from "ui/IconWithBg"
import styles from "./index.module.css"

const ExperienceMobileList = ({ experiences, onRemoveExperience }) => {
  return (
    <div className={styles.selectedExperiencesMobileList}>
      <div className={`${styles.mobileExperiencesHeader} py-xs px-m`}>
        <span className={styles.mobileExperiencesHeaderText}>Assigned to Experiences</span>
      </div>

      <div className={styles.selectedExperiencesMobileListWrap}>
        {experiences.map((exp) => {
          const isPublished = String(exp.status).toLowerCase() === "published"
          const statusText = String(exp.status).charAt(0).toUpperCase() + String(exp.status).slice(1)

          return (
            <div key={exp.id} className={`${styles.mobileExperienceCard} px-m py-xs`}>
              <Flex justify="space-between" align="center" className={styles.experienceCardRow}>
                <Flex vertical gap={5}>
                  <Tag
                    color={isPublished ? "green" : "default"}
                    icon={isPublished ? <CheckOutlined /> : null}
                    className={`${styles.statusPill} w-max`}
                  >
                    {statusText}
                  </Tag>

                  <Typography.Text strong className={styles.experienceName}>
                    {exp.name}
                  </Typography.Text>

                  <Flex align="center" className={styles.experienceCardRow} gap={12}>
                    <Typography.Text>{exp.guests} Guests</Typography.Text>
                    <Separator />
                    <Typography.Text>
                      {exp.currency}
                      {exp.price?.toFixed(2)}
                    </Typography.Text>
                  </Flex>
                </Flex>

                <IconWithBg
                  icon={<DeleteOutlined className={styles.deleteIcon} color="#525455" />}
                  onClick={() => onRemoveExperience(exp.id)}
                  className={styles.removeExperienceButton}
                  aria-label="Remove experience"
                />
              </Flex>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default ExperienceMobileList
